module.exports = __webpack_public_path__ + "img/icon_location.48257cf5.svg";